// Branchen-Landingpages (programmatic SEO). Jede Branche = eigener, einzigartiger Text
// (kein Duplicate Content). Weitere Branchen einfach als neuen Key ergänzen.

export const branchen = {
  "e-commerce": {
    path: "/branchen/e-commerce",
    eyebrow: "Branchen-Check · E-Commerce",
    breadcrumb: "E-Commerce & Onlineshops",
    hubTeaser: "Marge, Werbekosten & Retouren – wo Onlineshops wirklich scheitern.",
    ogImage: "https://static.prod-images.emergentagent.com/jobs/9116352b-e0e5-49e4-82fa-cc4f47892874/images/ac550f34f34af09d1e2ce3b600a374c99345cf1698bfae3cee95c2a5377f2f94.jpeg",
    seo: {
      title: "Onlineshop-Idee prüfen: Der ehrliche E-Commerce Reality-Check | Gründio",
      description:
        "Bevor du Ware bestellst: Lass deine E-Commerce- oder D2C-Idee auf Marge, CAC, Retouren & Cashflow prüfen. Ersteinschätzung gratis, Report mit über 10 Seiten für 29 €.",
      keywords:
        "onlineshop idee prüfen, e-commerce businessplan, d2c gründen, dropshipping rentabel, marge berechnen onlineshop",
    },
    hero: {
      h1: "Onlineshop starten? Was Standard-KI bei deinen Margen gefährlich übersieht.",
      sub:
        "Schluss mit Schönrederei. Während generische KI-Tools wichtige Variablen wie Marketingkosten oder Retouren-Risiken oft übergehen, benennt unser Report klar die Risiko-Faktoren hinter deiner Marge – und ordnet deinen größten Engpass ein.",
    },
    schmerz: {
      title: "Woran E-Commerce-Ideen wirklich scheitern",
      intro:
        "Nicht am Produkt – sondern an den Zahlen dahinter. Diese drei Faktoren entscheiden über schwarze oder rote Zahlen:",
      items: [
        {
          title: "Die Margen-Falle",
          desc:
            "Einkauf 8 €, Verkauf 29 € – klingt nach 21 € Gewinn? Nach Versand, Verpackung, Zahlungs- & Plattformgebühren bleibt oft nur ein Bruchteil übrig.",
        },
        {
          title: "CAC über Deckungsbeitrag",
          desc:
            "Ohne Reichweite kein Umsatz. Liegen deine Werbekosten pro Kunde über dem Deckungsbeitrag, verbrennst du mit jedem einzelnen Verkauf Geld.",
        },
        {
          title: "Retouren & Cashflow",
          desc:
            "Retourenquoten von 20–50 % (v. a. Fashion) und Vorkasse an Lieferanten fressen deine Liquidität, lange bevor der erste echte Gewinn ankommt.",
        },
      ],
    },
    reality: {
      title: "Warum generische KI-Prompts hier gefährlich sind",
      body: [
        "Standard-KI-Tools sind darauf optimiert, dir zuzustimmen. Fragst du sie nach deiner Shop-Idee, bekommst du meist Applaus statt einer nüchternen Rechnung.",
        "Genau die Faktoren, an denen Onlineshops real scheitern – Customer Acquisition Cost, Retouren, Zahlungsausfälle und Working Capital – werden dabei überflügelt oder mit Wohlfühl-Floskeln übergangen. Das erzeugt gefährliches Halbwissen und falsche Sicherheit.",
      ],
    },
    loesung: {
      title: "Der unvoreingenommene Reality-Check für deinen Shop",
      features: [
        { title: "Faktorbasierter Score (0–100)", desc: "Deine Idee wird anhand gewichteter Faktoren bewertet – kein Bauchgefühl, sondern eine nachvollziehbare Kennzahl." },
        { title: "Kritische Risiko-Einordnung", desc: "Der Report beleuchtet die branchentypischen Risiko-Faktoren – von Marge und Retouren bis Cashflow & Wirtschaftlichkeit – und ordnet deinen größten selbst genannten Engpass konkret ein." },
        { title: "Strukturierter Report (über 10 Seiten)", desc: "12 Kapitel mit klaren Schwachstellen, Chancen und einem konkreten 30-Tage-Plan als PDF." },
        { title: "Ehrlich statt gefällig", desc: "Kein Höflichkeits-Feedback. Du erfährst eine nüchterne Einordnung – was trägt und was nicht." },
      ],
    },
    ctaTitle: "Teste deine Shop-Idee, bevor du Ware bestellst.",
    ctaSub: "In ca. 60 Sekunden bekommst du eine erste Score-Tendenz und drei ehrliche Kurz-Urteile – kostenlos.",
  },

  "gastronomie": {
    path: "/branchen/gastronomie",
    eyebrow: "Branchen-Check · Gastronomie",
    breadcrumb: "Gastronomie & Café",
    hubTeaser: "Fixkosten, Personal & Auflagen – die realen Risiken hinter dem Gastro-Traum.",
    ogImage: "https://static.prod-images.emergentagent.com/jobs/9116352b-e0e5-49e4-82fa-cc4f47892874/images/5d716569b7477db5d669e68648731d131f263089644448e122c9afb4125fd544.jpeg",
    seo: {
      title: "Café oder Restaurant eröffnen: Der ehrliche Gastro-Reality-Check | Gründio",
      description:
        "Bevor du den Mietvertrag unterschreibst: Lass deine Gastro-Idee auf Fixkosten, Standort, Auflagen und Konzession prüfen. Ersteinschätzung gratis, Report mit über 10 Seiten für 29 €.",
      keywords:
        "café eröffnen, restaurant gründen, gastronomie businessplan, konzession gaststätte, imbiss eröffnen kosten, gastro selbstständig machen",
    },
    hero: {
      h1: "Restaurant oder Café eröffnen? Was Standard-KI bei Fixkosten und Auflagen unterschätzt.",
      sub:
        "Die Gastronomie ist ein Traum – und eine der kapitalintensivsten Branchen überhaupt. Während generische KI-Tools über Personalschlüssel, Konzession und Standort-Realität hinweggehen, benennt unser Report die entscheidenden Risiko-Faktoren und ordnet deinen größten Engpass ein.",
    },
    schmerz: {
      title: "Woran Gastro-Ideen wirklich scheitern",
      intro:
        "Selten am Essen – fast immer an der Kalkulation drumherum. Diese drei Faktoren entscheiden über volle oder leere Kassen:",
      items: [
        {
          title: "Die Fixkosten-Falle",
          desc:
            "Miete, Ausstattung, Kaution, Energie und Personal laufen ab Tag 1 – egal wie viele Gäste kommen. Ein zu optimistisch geplanter Standort frisst die Liquidität in wenigen Monaten.",
        },
        {
          title: "Auflagen & Konzession",
          desc:
            "Gaststättenkonzession, Gesundheitszeugnis, Hygiene nach HACCP, Lebensmittelüberwachung und Brandschutz sind Pflicht – und werden bei der Zeit- und Kostenplanung regelmäßig übersehen.",
        },
        {
          title: "Personal & Auslastung",
          desc:
            "Fachkräftemangel, hohe Lohnkosten und schwankende Auslastung (Mittag voll, Nachmittag leer) machen den Unterschied zwischen tragfähig und dauerdefizitär.",
        },
      ],
    },
    reality: {
      title: "Warum generische KI-Prompts hier gefährlich sind",
      body: [
        "Standard-KI-Tools sind darauf trainiert, dir zuzustimmen. Fragst du sie nach deiner Café-Idee, bekommst du eine schöne Beschreibung des Konzepts – aber keine nüchterne Einordnung der Standort- und Fixkosten-Realität.",
        "Genau die Faktoren, an denen Gastronomie real scheitert – Konzessionspflichten, Personalkosten, saisonale Auslastung und Working Capital – werden dabei überflügelt oder mit Wohlfühl-Floskeln übergangen. Das erzeugt gefährliche Planungssicherheit, die keine ist.",
      ],
    },
    loesung: {
      title: "Der unvoreingenommene Reality-Check für dein Lokal",
      features: [
        { title: "Faktorbasierter Score (0–100)", desc: "Deine Idee wird anhand gewichteter Faktoren bewertet – vom Kapitalbedarf bis zur Umsetzbarkeit am Standort. Eine nachvollziehbare Kennzahl statt Bauchgefühl." },
        { title: "Kritische Risiko-Einordnung", desc: "Der Report beleuchtet branchentypische Risiko-Faktoren – Fixkosten, Standort, Konzession, Auflagen – und ordnet deinen größten selbst genannten Engpass konkret ein." },
        { title: "Strukturierter Report (über 10 Seiten)", desc: "12 Kapitel mit Schwachstellen, Fördermöglichkeiten, Bank-Sparringfragen und einem konkreten 30-Tage-Plan als PDF." },
        { title: "Ehrlich statt gefällig", desc: "Kein Höflichkeits-Feedback. Du erfährst eine nüchterne Einordnung, bevor du einen langen Mietvertrag unterschreibst." },
      ],
    },
    ctaTitle: "Prüfe dein Gastro-Konzept, bevor du den Mietvertrag unterschreibst.",
    ctaSub: "In ca. 60 Sekunden bekommst du eine erste Score-Tendenz und drei ehrliche Kurz-Urteile – kostenlos.",
  },

  "handwerk": {
    path: "/branchen/handwerk",
    eyebrow: "Branchen-Check · Handwerk",
    breadcrumb: "Handwerk & Dienstleistung",
    hubTeaser: "Stundensatz, Auslastung & die Zeit-gegen-Geld-Falle im Handwerk.",
    ogImage: "https://static.prod-images.emergentagent.com/jobs/9116352b-e0e5-49e4-82fa-cc4f47892874/images/288c09c1fd8b337baffa7526beaed8521617220777ab4d633de31f04e3260103.jpeg",
    seo: {
      title: "Als Handwerker selbstständig machen: Der ehrliche Reality-Check | Gründio",
      description:
        "Meisterpflicht, Auslastung, Zahlungsausfälle: Lass deine Handwerks- oder Dienstleistungs-Idee auf die echten Risiko-Faktoren prüfen. Ersteinschätzung gratis, Report mit über 10 Seiten für 29 €.",
      keywords:
        "handwerk selbstständig machen, meisterpflicht gründung, handwerkskammer eintragung, dienstleistung gründen, stundensatz handwerker kalkulieren, betrieb übernehmen",
    },
    hero: {
      h1: "Als Handwerker selbstständig machen? Was Standard-KI zur Meisterpflicht verschweigt.",
      sub:
        "Dein Können steht außer Frage – aber trägt das Geschäftsmodell? Während generische KI-Tools Meisterpflicht, Auslastung und Zahlungsmoral ausblenden, benennt unser Report die entscheidenden Risiko-Faktoren und ordnet deinen größten Engpass ein.",
    },
    schmerz: {
      title: "Woran Handwerks-Gründungen wirklich scheitern",
      intro:
        "Nicht am Handwerk – an der Struktur dahinter. Diese drei Faktoren entscheiden über ein tragfähiges Geschäft:",
      items: [
        {
          title: "Meisterpflicht & Eintragung",
          desc:
            "Viele Gewerke sind zulassungspflichtig (Anlage A der HwO): ohne Meistertitel, Altgesellenregelung oder Ausnahmebewilligung keine Eintragung in die Handwerksrolle – ein häufig übersehener Show-Stopper.",
        },
        {
          title: "Die Zeit-gegen-Geld-Falle",
          desc:
            "Dein Umsatz hängt an deinen Arbeitsstunden. Ohne Team oder skalierbare Leistung ist die Decke schnell erreicht – und Krankheit oder Urlaub bedeuten Null-Umsatz.",
        },
        {
          title: "Auslastung & Zahlungsausfall",
          desc:
            "Schwankende Auftragslage, lange Zahlungsziele und einzelne säumige Kunden können die Liquidität kippen, obwohl die Auftragsbücher voll aussehen.",
        },
      ],
    },
    reality: {
      title: "Warum generische KI-Prompts hier gefährlich sind",
      body: [
        "Standard-KI-Tools loben dein Handwerk – aber sie prüfen nicht, ob dein Gewerk überhaupt zulassungsfrei ist oder ob deine Stundensatz-Logik die Fixkosten trägt.",
        "Genau die Faktoren, an denen Handwerksbetriebe real scheitern – Meisterpflicht, Auslastungsschwankungen, Zahlungsausfälle und fehlende Skalierbarkeit – werden dabei mit allgemeinen Ratschlägen übergangen. Das erzeugt trügerische Sicherheit.",
      ],
    },
    loesung: {
      title: "Der unvoreingenommene Reality-Check für deinen Betrieb",
      features: [
        { title: "Faktorbasierter Score (0–100)", desc: "Deine Idee wird anhand gewichteter Faktoren bewertet – von den Gründer-Voraussetzungen bis zur Umsetzbarkeit. Eine nachvollziehbare Kennzahl statt Bauchgefühl." },
        { title: "Kritische Risiko-Einordnung", desc: "Der Report beleuchtet branchentypische Risiko-Faktoren – Meisterpflicht, Auslastung, Zahlungsmoral, Skalierbarkeit – und ordnet deinen größten selbst genannten Engpass konkret ein." },
        { title: "Strukturierter Report (über 10 Seiten)", desc: "12 Kapitel mit Rechtsform-Orientierung, Fördermöglichkeiten, Bank-Sparringfragen und einem konkreten 30-Tage-Plan als PDF." },
        { title: "Ehrlich statt gefällig", desc: "Kein Höflichkeits-Feedback. Du erfährst eine nüchterne Einordnung, bevor du kündigst und dich selbstständig machst." },
      ],
    },
    ctaTitle: "Prüfe dein Handwerks-Konzept, bevor du dich selbstständig machst.",
    ctaSub: "In ca. 60 Sekunden bekommst du eine erste Score-Tendenz und drei ehrliche Kurz-Urteile – kostenlos.",
  },

  "saas-agentur": {
    path: "/branchen/saas-agentur",
    eyebrow: "Branchen-Check · SaaS & Agenturen",
    breadcrumb: "SaaS, Agenturen & digitale Services",
    hubTeaser: "Positionierung, Vertrieb & echte Skalierbarkeit digitaler Modelle.",
    ogImage: "https://static.prod-images.emergentagent.com/jobs/9116352b-e0e5-49e4-82fa-cc4f47892874/images/9fd396e14411387570df4288eccbd316b39bfb1de0300c2f58fcbb1a969691b4.jpeg",
    seo: {
      title: "SaaS oder Agentur gründen: Der ehrliche Reality-Check für digitale Modelle | Gründio",
      description:
        "Digitale Modelle wirken skalierbar – scheitern aber oft an Positionierung und Vertrieb. Lass deine SaaS- oder Agentur-Idee auf die echten Risiko-Faktoren prüfen. Ersteinschätzung gratis, Report für 29 €.",
      keywords:
        "saas gründen, agentur gründen, digitales business starten, kundengewinnung b2b, positionierung agentur, software startup validieren",
    },
    hero: {
      h1: "SaaS oder Agentur gründen? Warum Standard-KI die Vertriebsrealität ausblendet.",
      sub:
        "Digitale Modelle wirken mühelos skalierbar. Während generische KI-Tools die Positionierung feiern, benennt unser Report die eigentlichen Risiko-Faktoren – Kundengewinnung, Vertriebszyklus, Austauschbarkeit – und ordnet deinen größten Engpass ein.",
    },
    schmerz: {
      title: "Woran digitale Gründungen wirklich scheitern",
      intro:
        "Selten an der Technik – fast immer am Verkauf. Diese drei Faktoren entscheiden über echtes Wachstum:",
      items: [
        {
          title: "Unklare Positionierung",
          desc:
            "„Wir machen alles für jeden“ ist keine Positionierung. Ohne spitzes, zahlungsbereites Kundensegment und klaren Nutzen versinkt dein Angebot in einem austauschbaren Markt.",
        },
        {
          title: "Kundengewinnung & Vertriebszyklus",
          desc:
            "Vor allem im B2B-Umfeld dauern Verkaufsprozesse Monate. Ohne planbaren Vertriebsprozess bleibt der erhoffte, planbar wiederkehrende Umsatz aus.",
        },
        {
          title: "Skalierbarkeit vs. Projektgeschäft",
          desc:
            "Viele „SaaS“-Ideen sind in Wahrheit Dienstleistung. Steckt hinter jedem Kunden individuelle Handarbeit, skaliert das Modell nicht – und der Zeit-gegen-Geld-Deckel greift wie im Agenturgeschäft.",
        },
      ],
    },
    reality: {
      title: "Warum generische KI-Prompts hier gefährlich sind",
      body: [
        "Standard-KI-Tools lieben digitale Ideen – sie klingen modern und skalierbar. Genau deshalb bekommst du dort Applaus statt einer nüchternen Prüfung deines Go-to-Market.",
        "Die Faktoren, an denen SaaS und Agenturen real scheitern – unscharfe Positionierung, hohe Kundengewinnungskosten, lange Vertriebszyklen und fehlende Differenzierung – werden mit Buzzwords übergangen. Das erzeugt gefährliche Selbstsicherheit.",
      ],
    },
    loesung: {
      title: "Der unvoreingenommene Reality-Check für dein digitales Modell",
      features: [
        { title: "Faktorbasierter Score (0–100)", desc: "Deine Idee wird anhand gewichteter Faktoren bewertet – von Marktchance bis Umsetzbarkeit. Eine nachvollziehbare Kennzahl statt Hype." },
        { title: "Kritische Risiko-Einordnung", desc: "Der Report beleuchtet branchentypische Risiko-Faktoren – Positionierung, Vertriebsmachbarkeit, Kundengewinnung, Skalierbarkeit – und ordnet deinen größten selbst genannten Engpass konkret ein." },
        { title: "Strukturierter Report (über 10 Seiten)", desc: "12 Kapitel mit Zielgruppen-Schärfung, Marketing- & Vertriebsstruktur, Bank-Sparringfragen und einem konkreten 30-Tage-Plan als PDF." },
        { title: "Ehrlich statt gefällig", desc: "Kein Höflichkeits-Feedback. Du erfährst eine nüchterne Einordnung, bevor du Monate in ein Produkt ohne Käufer steckst." },
      ],
    },
    ctaTitle: "Prüfe dein digitales Modell, bevor du monatelang entwickelst.",
    ctaSub: "In ca. 60 Sekunden bekommst du eine erste Score-Tendenz und drei ehrliche Kurz-Urteile – kostenlos.",
  },

  "beauty-wellness": {
    path: "/branchen/beauty-wellness",
    eyebrow: "Branchen-Check · Beauty & Wellness",
    breadcrumb: "Beauty, Kosmetik & Wellness",
    hubTeaser: "Auslastung, Standort & Preisdruck in Beauty & Wellness.",
    ogImage: "https://static.prod-images.emergentagent.com/jobs/9116352b-e0e5-49e4-82fa-cc4f47892874/images/6bb541305fd9fc70c314ea7b1e9223bde9abed6cca50703ea12538c2750604fe.jpeg",
    seo: {
      title: "Kosmetik- oder Wellnessstudio eröffnen: Der ehrliche Reality-Check | Gründio",
      description:
        "Zulassung, Auslastung, Preis-Marge: Lass deine Beauty-, Kosmetik- oder Wellness-Idee auf die echten Risiko-Faktoren prüfen. Ersteinschätzung gratis, Report mit über 10 Seiten für 29 €.",
      keywords:
        "kosmetikstudio eröffnen, nagelstudio gründen, wellness selbstständig, friseursalon eröffnen, kosmetik selbst herstellen verkaufen, beauty business starten",
    },
    hero: {
      h1: "Kosmetik- oder Wellnessstudio starten? Was Standard-KI bei Zulassung und Marge übersieht.",
      sub:
        "Der Markt boomt – und ist hart umkämpft und teils streng reguliert. Während generische KI-Tools über Auslastung, Hygiene-Auflagen und Produkt-Zulassung hinweggehen, benennt unser Report die entscheidenden Risiko-Faktoren und ordnet deinen größten Engpass ein.",
    },
    schmerz: {
      title: "Woran Beauty- & Wellness-Ideen wirklich scheitern",
      intro:
        "Selten am Talent – fast immer an Auslastung und Regulierung. Diese drei Faktoren entscheiden über ein tragfähiges Studio:",
      items: [
        {
          title: "Auslastung & Terminlücken",
          desc:
            "Dein Umsatz hängt an gebuchten Stunden. Leerlauf zwischen Terminen, Absagen und saisonale Schwankungen drücken die Auslastung – während Miete und Ausstattung konstant weiterlaufen.",
        },
        {
          title: "Zulassung, Hygiene & Produkt-Regeln",
          desc:
            "Je nach Angebot greifen strenge Regeln: Hygieneauflagen, Anzeigepflichten, bei eigenen Kosmetikprodukten das EU-Meldeportal CPNP und die Kosmetik-Verordnung. Wird schnell zum unterschätzten Hürdenlauf.",
        },
        {
          title: "Preis-Marge & Wettbewerb",
          desc:
            "Verbrauchsmaterial, Geräte-Abschreibung und ein oft dichter lokaler Wettbewerb drücken die Marge. Zu niedrige Preise bei zu hohen Fixkosten sind eine typische Falle.",
        },
      ],
    },
    reality: {
      title: "Warum generische KI-Prompts hier gefährlich sind",
      body: [
        "Standard-KI-Tools schwärmen vom boomenden Beauty-Markt – aber sie prüfen nicht, ob dein Standort die nötige Auslastung hergibt oder ob deine Eigenprodukte überhaupt verkehrsfähig sind.",
        "Die Faktoren, an denen Studios real scheitern – schwache Auslastung, regulatorische Auflagen, dünne Margen und hoher lokaler Wettbewerb – werden mit Wohlfühl-Floskeln übergangen. Das erzeugt eine gefährliche Schönfärberei.",
      ],
    },
    loesung: {
      title: "Der unvoreingenommene Reality-Check für dein Studio",
      features: [
        { title: "Faktorbasierter Score (0–100)", desc: "Deine Idee wird anhand gewichteter Faktoren bewertet – von Kapitalbedarf bis Marktchance am Standort. Eine nachvollziehbare Kennzahl statt Bauchgefühl." },
        { title: "Kritische Risiko-Einordnung", desc: "Der Report beleuchtet branchentypische Risiko-Faktoren – Auslastung, Auflagen, Produkt-Zulassung, Wettbewerb – und ordnet deinen größten selbst genannten Engpass konkret ein." },
        { title: "Strukturierter Report (über 10 Seiten)", desc: "12 Kapitel mit Standortanalyse, Compliance-Hinweisen, Bank-Sparringfragen und einem konkreten 30-Tage-Plan als PDF." },
        { title: "Ehrlich statt gefällig", desc: "Kein Höflichkeits-Feedback. Du erfährst eine nüchterne Einordnung, bevor du in Ausstattung und Ladenlokal investierst." },
      ],
    },
    ctaTitle: "Prüfe dein Studio-Konzept, bevor du in Ausstattung investierst.",
    ctaSub: "In ca. 60 Sekunden bekommst du eine erste Score-Tendenz und drei ehrliche Kurz-Urteile – kostenlos.",
  },
};
